import { addZero } from "../../../utils/addZero";
import { getShortYear } from "../../../utils/getShortYear";

export const getMessageCreationDate = (ms) => {
  const date = new Date(ms);
  const dd = `${addZero(date.getDate())}`;
  const mm = `${addZero(date.getMonth() + 1)}`;
  const yy = `${getShortYear(date.getFullYear())}`
  return `${dd}/${mm}/${yy}`;
}
